// 会议折叠面板初始化配置相关的
import { useMemo, useState, useEffect } from 'react';
import { getSecureMaxShowOfMeetingsPanels } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Management/Details/components/Meetings/utils';

// 会议折叠面板初始化配置相关的
export default function useMeetingPanelInitialConfig(options: {
  expandedMeetingId: string | number;
  meetingsPanels: IStudioManagementCollapsiblePanel[];
  maxShow?: number;
}) {
  const { expandedMeetingId, meetingsPanels = [], maxShow: maxShowProps } = options || {};

  // 是否默认完全展示会议记录
  const [isShowAll, setIsShowAll] = useState(false);

  // 处理后的maxShow（安全值，如果传入的maxShowProps值异常，则使用默认兜底的值）
  const maxShow = useMemo(() => getSecureMaxShowOfMeetingsPanels(maxShowProps), [maxShowProps]);

  /**
   * 如果默认展开的会议，在maxShow之后（即默认显示会议之后，没有显示出来，需要点击Show All才会显示的）
   * 就需要触发Show All，完全展示所有会议
   */
  useEffect(() => {
    const defaultExpandedMeetingIndex = meetingsPanels?.findIndex(
      (meetingPanel) => String(meetingPanel?.data?.id) === String(expandedMeetingId),
    );
    if (defaultExpandedMeetingIndex !== -1 && defaultExpandedMeetingIndex > maxShow - 1) {
      setIsShowAll(true);
    }
  }, [expandedMeetingId, maxShow, meetingsPanels]);

  return {
    isShowAll,
    maxShow,
  };
}
